import imageCompress from 'browser-image-compression'
import _uniqueId from 'lodash/uniqueId'

export const compressImage = (
	file: File | Blob,
	options: Record<string, unknown> = {},
): Promise<File> => {
	return new Promise((resolve, reject) => {
		const imageFile = file
		const fileId = _uniqueId('file_')

		const compressionOptions: Record<string, unknown> = {
			maxSizeMB: 0.2,
			maxWidthOrHeight: 1920,
			useWebWorker: true,
		}

		if (options) {
			// eslint-disable-next-line no-restricted-syntax
			for (const key in options) {
				// eslint-disable-next-line no-prototype-builtins
				if (options.hasOwnProperty(key)) {
					const optionVal = options[key]
					compressionOptions[key] = optionVal
				}
			}
		}
		let fileName = fileId
		if (imageFile instanceof File && imageFile.name) {
			fileName += `_${imageFile.name}`
		}

		imageCompress(new File([imageFile], fileName, { type: imageFile.type }), compressionOptions)
			.then((compressedFile: File) => {
				const compressedImg = new File([compressedFile], fileName, { type: compressedFile.type })

				resolve(compressedImg)
			})
			.catch((error) => reject(error))
	})
}
export const blobToBase64 = (blob: Blob | File): Promise<string | ArrayBuffer | null> => {
	return new Promise((resolve, reject) => {
		try {
			const reader = new FileReader()
			reader.onloadend = () => resolve(reader.result)
			reader.readAsDataURL(blob)
		} catch (err) {
			reject(err)
		}
	})
}

export const blobToFile = (blob: Blob): Promise<File> => {
	return new Promise((resolve, reject) => {
		try {
			const fileId = _uniqueId('file_')
			const filename = fileId
			const file = new File([blob], filename, { type: blob.type })

			resolve(file)
		} catch (error) {
			reject(error)
		}
	})
}

export const resizeImage = (
	imageSrc: string | File,
	maxWidth: number,
	maxHeight: number,
): Promise<Blob> => {
	return new Promise((resolve, reject) => {
		const img = new Image()
		img.src = typeof imageSrc === 'string' ? imageSrc : URL.createObjectURL(imageSrc)
		img
			.decode()
			.then(() => {
				const canvas = document.createElement('canvas')
				const MAX_WIDTH = maxWidth
				const MAX_HEIGHT = maxHeight
				let { width } = img
				let { height } = img

				if (height > MAX_HEIGHT) {
					throw new Error('MAX_HEIGHT_EXCEEDED')
				}

				if (width > MAX_WIDTH) {
					height *= MAX_WIDTH / width
					width = MAX_WIDTH
				}

				canvas.width = width
				canvas.height = height

				const ctx = canvas.getContext('2d')

				ctx?.drawImage(img, 0, 0, width, height)

				canvas.toBlob((blob) => {
					if (blob === null) {
						reject(new Error())
						return
					}

					resolve(blob)
				}, 'image/jpg')
			})
			.catch((error) => reject(error))
	})
}
